  /* jshint ignore:start */
})(jQuery); // Fully reference jQuery after this point.
  /* jshint ignore:end */
